/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubsystemOneResponseDto
 */
export interface SubsystemOneResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SubsystemOneResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SubsystemOneResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof SubsystemOneResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SubsystemOneResponseDto
     */
    description?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SubsystemOneResponseDto
     */
    metadataSchema?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof SubsystemOneResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubsystemOneResponseDto
     */
    updatedAt: Date;
    /**
     * Array of asset type IDs associated with this subsystem
     * @type {Array<string>}
     * @memberof SubsystemOneResponseDto
     */
    assetTypes?: Array<string>;
}

/**
 * Check if a given object implements the SubsystemOneResponseDto interface.
 */
export function instanceOfSubsystemOneResponseDto(value: object): value is SubsystemOneResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SubsystemOneResponseDtoFromJSON(json: any): SubsystemOneResponseDto {
    return SubsystemOneResponseDtoFromJSONTyped(json, false);
}

export function SubsystemOneResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubsystemOneResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'metadataSchema': json['metadataSchema'] == null ? undefined : json['metadataSchema'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'assetTypes': json['assetTypes'] == null ? undefined : json['assetTypes'],
    };
}

export function SubsystemOneResponseDtoToJSON(json: any): SubsystemOneResponseDto {
    return SubsystemOneResponseDtoToJSONTyped(json, false);
}

export function SubsystemOneResponseDtoToJSONTyped(value?: SubsystemOneResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
        'metadataSchema': value['metadataSchema'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'assetTypes': value['assetTypes'],
    };
}

